import { Button, Chip, Theme, Typography, WithStyles, withStyles } from "@material-ui/core";
import { Paper } from "@meeva/ontheme/Container/Paper";
import classNames from "classnames";
import { push } from "connected-react-router";
import { fromEvent } from "file-selector";
import * as React from "react";
import Dropzone from "react-dropzone";
import { connect, Omit } from "react-redux";
import { AppContext } from "src";
import App from "../app";
import { FileDoc } from "../db/File";
import { AppState } from "../redux";

const styles = (theme: Theme) => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2
  },
  chipContainer: {
    display: "flex",
    justifyContent: "center" as "center",
    flexWrap: "wrap" as "wrap"
  },
  chip: {
    margin: theme.spacing.unit
  }
});

interface Props extends WithStyles<typeof styles> {
  app: App;
  loading: boolean;
  loadedFiles: FileDoc[];
  link: (path: string) => void;
}

class Upload extends React.Component<Props> {
  public removeFile(fileId: string) {
    return this.props.app.removeFile(fileId);
  }
  public async reset(e: React.SyntheticEvent) {
    this.props.app.reset();
    e.preventDefault();
  }
  public uploadFile = (acceptedFiles: File[]) => {
    return this.props.app.loadFiles(acceptedFiles);
  };

  public render() {
    const { classes } = this.props;

    return (
      <Paper className={classes.paper}>
        <Typography variant="h5">Weitere Datei Hinzufügen</Typography>
        <Dropzone getDataTransferItems={fromEvent} onDrop={this.uploadFile}>
          {({ getRootProps, getInputProps, isDragActive }) => (
            <div {...getRootProps()} className={classNames("dropzone", { active: isDragActive })}>
              <input {...getInputProps()} />
              <Typography>Anklicken oder per Drag&Drop hereinziehen</Typography>
              <div className={classes.chipContainer}>
                {this.props.loadedFiles.map((f, i) => {
                  return (
                    <Chip
                      // avatar={<Avatar alt="Natacha" src="/static/images/uxceo-128.jpg" />}
                      key={i}
                      label={f.fileName}
                      onDelete={() => this.removeFile(f._id)}
                      className={classes.chip}
                    />
                  );
                })}
              </div>
            </div>
          )}
        </Dropzone>
        {this.props.loadedFiles.length > 0 && (
          <div style={{ marginTop: "1em" }}>
            <Button onClick={e => this.reset(e)}>zurücksetzen</Button>
          </div>
        )}
      </Paper>
    );
  }
}

const UploadApp = (props: Omit<Props, "app">) => <AppContext.Consumer>{app => <Upload {...props} app={app} />}</AppContext.Consumer>;

export default withStyles(styles)(
  connect(
    (state: AppState) => ({
      loading: state.loading.status,
      loadedFiles: state.fileList
    }),
    dispatch => ({
      link: (path: string) => dispatch(push(path))
    })
  )(UploadApp)
);



// WEBPACK FOOTER //
// ./src/Main/Upload.tsx